module.exports = __webpack_public_path__ + "static/media/boarding pass.3fd2cce9.PNG";